export enum LoadState {
  NotLoaded = 0,
  InProgress = 1,
  Loaded = 2,
  Failed = 3,
}

export enum SaveState {
  NotStarted = 0,
  Progress = 1,
  Saved = 2,
}

export enum TASK_SUBTYPE {
  VEHICLE_CHANGE = "Vehicle Change",
  DRIVER_CHANGE = "Driver Change",
  COVERAGE_CHANGE = "Coverage Change",
  GARAGE_PLATE_CHANGE = "Garage Plate Change",
  INTERESTED_PARTY_CHANGE = "Interested Party Change",
  LESSOR_CHANGE = "Lessor Change",
  ADDRESS_CHANGE = "Address Change",
  RISK_LOCATION_CHANGE = "Risk Location Change",
  CANCELLATION_REINSTALLMENT = "Cancellation/Reinstatement",
  BUSINESS_SUBMISSION = "Business Submission",
  GENERAL_CHANGE = "General Change",
  PAYMENT_AUTH_CHANGE = "Payment Authorization Change",
  LAO_BOR = "LOA/BOR",
  LETTER_OF_EXPERIENCE = "Letter of Experience",

  NEW_BUSINESS = "Business",
  NEW_PERSONAL_AUTO = "Personal Auto",
  NEW_HOME = "Home",
  NEW_COMMERCIAL_AUTO = "Commercial Auto",
  NEW_PERSONAL_AND_HOME = "Personal Auto & Home",
  REMARKET_COMMERCIAL_AUTO = "Commercial Auto",
  REMARKET_HOME = "Home",
  REMARKET_BUSINESS = "Business",
  REMARKET_PERSONAL_AUTO = "Personal Auto",
  REMARKET_PERSONAL_AND_HOME = "Personal Auto & Home",
  QUOTE_REQUEST = "Quote Request",
  TASK_CERTIFICATE_OF_INSURANCE = "Certificate of Insurance",
}

export enum POLICIES {
  BUSINESS_POLICY = "Business Policy",
  AUTOMOBILE_POLICY = "Automobile Policy",
  HABITATIONAL_POLICY = "Habitational Policy",
  COMMERCIAL_AUTO_POLICY = "Commercial Auto Policy",
  LIFE_AND_FINCANCIAL_POLICY = "Life & Financial Policy",
}

export enum POLICIES_NAMES {
  BUSINESS_POLICY = "Business",
  AUTOMOBILE_POLICY = "Automobile",
  HABITATIONAL_POLICY = "Habitational",
  COMMERCIAL_AUTO_POLICY = "Commercial Auto",
  LIFE_AND_FINCANCIAL_POLICY = "Life & Financial",
}

export enum POLICY_STATUS {
  BUSINESS_POLICY = "business",
  AUTOMOBILE_POLICY = "automobile",
  HABITATIONAL_POLICY = "habitational",
  COMMERCIAL_AUTO_POLICY = "commauto",
}

export const getPolicyTypeEnum = (
  policyType: string | undefined,
): POLICY_STATUS => {
  switch (policyType) {
    case "Automobile Policy":
      return POLICY_STATUS.AUTOMOBILE_POLICY;
    case "Habitational Policy":
      return POLICY_STATUS.HABITATIONAL_POLICY;
    case "Commercial Auto Policy":
      return POLICY_STATUS.COMMERCIAL_AUTO_POLICY;
    default:
      return POLICY_STATUS.BUSINESS_POLICY;
  }
};

export enum ERROR_MESSAGES {
  "NO_RECORD_FOUND" = "Unfortunately, there are no records available at the moment.",
  "SERVER_ERROR" = "Someting went to be wrong!",
  "POLICY_NOT_FOUND" = "Oops! We couldn't find any records at the moment. Please ensure that the provided information is accurate and try again.",
}

export enum MODULE_IDS {
  NONE = -1,
  LEADS = "LEADS|LEADS|LATEST_LEADS_WITHOUT_OPPORTUNITY_STATUS",
  CLAIMS = "POLICY|ALL POLICY CLAIMS|NAT_ALL_POLICY_CLAIMS",
  FOLLOW_UP = "LEADS|FOLLOWUP|LATEST_FOLLOWUP",
  OPPORTUNITY = "OPPORTUNITY|OPPORTUNITY|LATEST_LEAD_WITH_OPPORTUNITY",
  BUSINESS_POLICY = "POLICY|BUSINESS POLICY|LATEST_POLICY_BUSINESS_CUSTOMER_INFO",
  COMMERCIAL_AUTO = "POLICY|COMMERCIAL AUTOMOBILE POLICY|LATEST_POLICY_COMMAUTO_CUSTOMER_INFO",
  AUTOMOBILE = "POLICY|AUTOMOBILE POLICY|LATEST_POLICY_AUTOMOBILE_CUSTOMER_INFO",
  HABITATIONAL = "POLICY|HABITATIONAL POLICY|LATEST_POLICY_HABITATIONAL_CUSTOMER_INFO",
  CUSTOMER = "CUSTOMER|CUSTOMER|LATEST_CUSTOMER_ALL_DETAILED_RECORD",
  LIFE_AND_FINCANCIAL = "POLICY|LIFE AND FINANCIAL POLICY|LATEST_POLICY_LIFE_BASIC_DETAILS_CUSTOMER_INFO",
  // ALL_POLICY = "POLICY|ALL POLICY|LATEST_ALL_CUSTOMER_POLICY_DETAILS",
  ALL_POLICY = "POLICY|ALL POLICY|LATEST_ALL_CUSTOMER_POLICY_DETAILS",
  LEGAL = "LEGAL PLUS|LEGAL PLUS|LATEST_LEGAL_PLUS",

  // HR
  HR_APPLICATION = "HR|APPLICATION FORM|LATEST_HR_APPLICATION_FORM",
  HR_ONBOARDING = "HR|ON BOARDING CHECKLIST|LATEST_HR_ONBOARDING_CHECKLIST",
  HR_OFFBOARDING = "HR|USER OFF BOARDING|LATEST_HR_USER_OFFBOARDING",
  HR_REQUEST_FORMS = "HR|REQUEST FORMS|LATEST_HR_USER_REQUEST",

  // Brokerage
  INSURER = "BROKERAGE|INSURER CODE|LATEST_INSURER_CODE",
  UNDERWRITERS = "BROKERAGE|UNDERWRITERS|LATEST_UNDERWRITERS",
  CSIO_COMPANY = "BROKERAGE|CSIO COMPANY|LATEST_CSIO_COMPANY",
  POLICY_COMISSION = "BROKERAGE|POLICY COMMISSION|LATEST_POLICY_COMMISSION",
  INSURER_CONTACTS = "BROKERAGE|INSURER CONTACTS|LATEST_INSURER_CONTACTS",
  BRANCH_OFFICES = "BROKERAGE|BRANCH OFFICE|LATEST_BRANCH_OFFICE",
  BROKER_CODES = "BROKERAGE|BROKER CODE|LATEST_BROKER_CODE",
  INSURER_SUB = "BROKERAGE|INSURER SUB|LATEST_INSURER_SUB",
  ADDITIONAL_INTERESTS = "BROKERAGE|ADDITIONAL INTEREST|LATEST_ADDITIONAL_INTEREST",
  INTERESTED_PARTIES = "BROKERAGE|INTERESTED PARTY|LATEST_INTERESTED_PARTY",
  BROKER_CONTACTS = "BROKERAGE|BROKER CONTRACTS|LATEST_BROKER_CONTRACTS",
  APPS_AND_FORMS = "BROKERAGE|APPS AND FORMS|LATEST_APPS_AND_FORMS",
  COMPANY_EQUIPMENT = "BROKERAGE|COMPANY EQUIPMENTS|LATEST_BROKERAGE_EQUIPMENT",

  // Security
  ROLE = "SECURITY|ROLE|ROLE",
  ROLE_MODULE = "SECURITY|ROLE MODULE|ROLE_MODULE",
  AUTOMATION = "SECURITY|AUTOMATION|LATEST_WORKFLOW_BASIC",
  UTILS = "SECURITY|UTILS|NAT_SECURITY_UTILS",

  // Template
  TEMPLATES = "TEMPLATE|TEMPLATE|LATEST_TEMPLATES",

  // User
  USERS = "USER|USER|LATEST_USER",
  USER_PROFILE = "USER|USER PROFILE|LATEST_USER",
  USER_DOCUMENTS = "USER|USER DOCUMENT|LATEST_USER_DOCUMENT",
  USER_SECURITY_GROUP = "USER|USER SECURITY|LATEST_USER_GROUP_SECURITY",
  USER_COMMISSION = "USER|USER COMMISSION|LATEST_USER_COMMISSION",


  // Task
  STAFF_USER = "USER|STAFF USER|LATEST_USER",
  TASK_NOTICES = "TASK|NOTICE|LATEST_NOTICE",
  ALL_TASK = "TASK|ALL TASK|LATEST_TASK",
  TASK_CALENDER = "TASK|CALENDER|CALENDER",
  TASK_TASKBOARD = "TASK|TASKBOARD|LATEST_TASK_USER_TASKBOARD",
  TASK_RENEWALS = "TASK|RENEWALS|LATEST_TASK_RENEWABLE",
  TASK_BINDERS = "TASK|BINDERS|LATEST_GET_ALL_BINDER_RECORD",
  ALL_BINDERS = "TASK|ALL BINDER|LATEST_ALL_CUSTOMER_BINDER_DETAILS",
  TASK_MARKETING = "TASK|MARKETING|LATEST_GET_ALL_MARKETING_HISTORY",
  TASK_CERTIFICATE_OF_INSURANCE = "TASK|CERTIFICATE OF INSURANCE|LATEST_TASK_CERTIFICATE_OF_INSURANCE",
  INSURANCE_REPORTS = "TASK|INSURANCE REPORTS|LATEST_TASK_DRIVER_INSURANCE_REPORT",
  NO_POLICY_INSURANCE_REPORTS = "TASK|NO POLICY INSURANCE REPORTS|LATEST_POLICY_NO_POLICY_DRIVER_INSURANCE_REPORTS",
  NOTES = "TASK|NOTES|LATEST_NOTES",
  OLD_BUSINESS_TRACKER = "TASK|OLD BUSINESS TRACKER|OLD_BUSINESS_TRACKER",
  OLD_INSURANCE_REPORTS = "TASK|OLD INSURANCE REPORTS|OLD_INSURANCE_REPORTS",
  ABEYANCE_NOTES = "TASK|ABEYANCE/NOTES|LATEST_ALL_CUSTOMER_POLICY_DETAILS",
  POLICY_CHANGE_REQUEST = "TASK|POLICY CHANGE REQUEST|LATEST_ALL_POLICY_CHANGE_REQUEST",
  TASK_PREMIMUM_FINANCE = "POLICY|PREMIUM FINANCE AGREEMENT|LATEST_POLICY_BUSINESS_PREMIUM_FINANCE_AGREEMENT",

  // policy admin manager

  AUTO_POLICY_ADMIN_MANAGER = "POLICY ADMIN MANAGER|AUTOMOBILE POLICY ADMIN|LATEST_POLICY_AUTOMOBILE_POLICY_ADMIN",
  BUSINESS_POLICY_ADMIN_MANAGER = "POLICY ADMIN MANAGER|BUSINESS POLICY ADMIN|LATEST_POLICY_BUSINESS_POLICY_ADMIN",
  COMM_AUTO_POLICY_ADMIN_MANAGER = "POLICY ADMIN MANAGER|COMMERCIAL POLICY ADMIN|LATEST_POLICY_COMMAUTO_POLICY_ADMIN",
  HABITATIONAL_POLICY_ADMIN_MANAGER = "POLICY ADMIN MANAGER|HABITATIONAL POLICY ADMIN|LATEST_POLICY_HABITATIONAL_POLICY_ADMIN",
  LIFE_AND_FINCANCIAL_POLICY_ADMIN_MANAGER = "POLICY ADMIN MANAGER|LIFE AND FINANCIAL POLICY ADMIN|LATEST_POLICY_LIFE_BASIC_DETAILS_POLICY_ADMIN",

  G4_SIGN = "G4 SIGN|DOCUMENTS|LATEST_SIGN_DOCUMENT",
  CSIO = "CSIO|CSIO|LATEST_CSIO_RETRIEVE_MESSAGES",
  CSIO_EDOCS = "CSIO|EDOC|LATEST_CSIO_EDOC",
  CSIO_MAPPING = "CSIO|CSIO MAPPING|NAT_CSIO_MAPPING",
  CSIO_CRON = "CSIO|CSIO CRON|NAT_CSIO_CRON",
  SUPPORT_TICKET = "SUPPORT TICKET|SUPPORT TICKET|LATEST_SUPPORT_TICKETS",
  COMMUNICATION = "COMMUNICATION|COMMUNICATION|NAT_COMMUNICATION",

  EQUIPMENT = "BROKERAGE|COMPANY EQUIPMENTS|LATEST_BROKERAGE_EQUIPMENT",

  TASK_ACTIVITIES = "TASK|TASK MODULE WISE|LATEST_TASK_MODULE_WISE",
  TASK_APPROVALS = "TASK|TASK MODULE WISE ONLY FOR APPROVAL|LATEST_TASK_MODULE_WISE_ONLY_FOR_APPROVAL",

  ACCOUNTING_INVOICES_LIST = "ACCOUNTING|INVOICING|LATEST_ACCN_INVOICE_INFORMATION",
  ACCOUNTING_INVOICE_PAYMENT = "ACCOUNTING|INVOICE PAYMENT|LATEST_ACCN_INVOICE_PAYMENT_ACCOUNTS_RECEIVABLE",
  ACCOUNTING_BILLS_LIST = "ACCOUNTING|BILL|LATEST_ACCN_CREATE_BILL",
  ACCOUNTING_BILL_PAYMENT = "ACCOUNTING|BILL PAYMENT|LATEST_ACCN_CREATE_PAYMENT",
  ACCOUNTING_BILL_CHEQUES = "ACCOUNTING|CHEQUES|LATEST_ACCN_CHEQUE",
  ACCOUNTING_JE_ENTRY_LIST = "ACCOUNTING|JE ENTRY|LATEST_JE_ENTRY",
  ACCOUNTING_CHARTS_OF_ACCOUNTS = "ACCOUNTING|CHARTS OF ACCOUNTS|LATEST_ACCN_COMPANY_CHARTS_OF_ACCOUNTS",
  ACCOUNTING_VENDORS_LIST = "ACCOUNTING|VENDOR|LATEST_ACCN_VENDOR",
  ACCOUNTING_SETTINGS_ACCOUNTS = "ACCOUNTING|GL ACCOUNTS|LATEST_ACCN_COMPANY_GL_ACCOUNTS",
  ACCOUNTING_SETTINGS_INVOICE_TEMPLATE = "ACCOUNTING|INVOICE TEMPLATE|LATEST_ACCN_INVOICE_TEMPLATE",
  ACCOUNTING_SETTINGS_TAX_TABLE = "ACCOUNTING|TAX|LATEST_ACCN_TAX",
  ACCOUNTING_SETTINGS_TRANSACTION_TYPES = "ACCOUNTING|TRANSACTION TYPE|LATEST_ACCN_TRANSACTION_TYPE",
  ACCOUNTING_SETTINGS_TRANSACTION_DESCRIPTION_LIST = "ACCOUNTING|TRANSACTION DESCRIPTION|LATEST_ACCN_TRANSACTION_DESCRIPTION",
  ACCOUNTING_SETTINGS_BILL_TEMPLATES = "ACCOUNTING|BILL TEMPLATE|LATEST_ACCN_BILL_TEMPLATE",
  ACCOUNTING_SETTINGS_BILL_TRANSACTION_TYPES = "ACCOUNTING|BILL TRANSACTION TYPE|LATEST_ACCN_BILL_TRANSACTION_TYPE",
  ACCOUNTING_SETTINGS_JOURNAL_TYPES = "ACCOUNTING|JE TYPE|LATEST_JE_TYPE",
  ACCOUNTING_SETTINGS_FISCAL_PERIODS = "ACCOUNTING|FISCAL YEARS|LATEST_FISCAL_YEARS",
  ACCOUNTING_TASKS = "ACCOUNTING|TASK MODULE WISE ONLY FOR ACCOUNTING|LATEST_TASK_MODULE_WISE_ONLY_FOR_ACCOUNTING",
  ACCOUNTING_INVOICES_TRANSACTIONS = "ACCOUNTING|INVOICE TRANSACTION ITEMS|LATEST_ACCN_INVOICE_TRANSACTION_ITEMS",

  REPORTS = "ACCOUNTING|TRANSACTION REPORT HISTORY|ACCN_TRANSACTION_REPORT_HISTORY",
  REPORTS_GENERAL_LEDGER = "ACCOUNTING|GL ACCOUNT DETAILS|ACCN_GL_ACCOUNT_DETAILS",
  REPORTS_SALES_AND_COMMISSION = "ACCOUNTING|SALES AND COMMISSION SUMMARY|NAT_GET_SALES_AND_COMMISSION_SUMMARY",

  REPORTS_BALANCE_SHEET = "",
  REPORTS_RIBO_FORM1 = "",
  REPORTS_REMITTANCE_INSURER_VENDOR = "",
  REPORTS_AGENT_INSURER_VENDOR = "",

  REPORTS_CUSTOMER_STATEMENT = "ACCOUNTING|CUSTOMER STATEMENTS|NAT_GET_ACCN_CUSTOMER_STATEMENTS",
  REPORTS_ACCOUNTS_RECEIVABLE_DETAILED = "ACCOUNTING|ACCOUNT RECEIVABLE DETAILED REPORT|NAT_GET_ACCN_ACCOUNT_RECEIVABLE_DETAILED_REPORT",
  REPORTS_ACCOUNTS_RECEIVABLE_SUMMARY = "ACCOUNTING|ACCOUNT RECEIVABLE SUMMARY REPORT|NAT_GET_ACCN_ACCOUNT_RECEIVABLE_SUMMARY_REPORT",
  REPORTS_ACCOUNTS_PAYABLE = "ACCOUNTING|ACCOUNT PAYABLE REPORT|NAT_GET_ACCN_ACCOUNT_PAYABLE_REPORT",
  REPORTS_TAX_REMITTANCE = "ACCOUNTING|INVOICE TRANSACTION ITEMS|LATEST_ACCN_INVOICE_TRANSACTION_ITEMS",
  REPORTS_OPERATING_STATEMENTS = "ACCOUNTING|INVOICE TRANSACTION ITEMS|LATEST_ACCN_INVOICE_TRANSACTION_ITEMS",

  RECONCILIATION_LIST = "ACCOUNTING|RECONCILIATION SUMMARY|LATEST_RECONCILIATION_SUMMARY",
  RECONCILIATION_MANUAL_RECONCILIATION = "ACCOUNTING|INVOICE TRANSACTION ITEMS|LATEST_ACCN_INVOICE_TRANSACTION_ITEMS",
  RECONCILIATION_MANUAL_BANK_RECONCILIATION = "ACCOUNTING|INVOICE PAYMENT TRANSACTION ITEMS|LATEST_ACCN_INVOICE_PAYMENT_TRANSACTION_ITEMS",
  RECONCILIATION_DUPLICATE_TRANSACTION_ITEMS = "ACCOUNTING|INVOICE TRANSACTION ITEMS|LATEST_ACCN_INVOICE_TRANSACTION_ITEMS",
  MASTER_DROPDOWNS = "GENERAL|DROPDOWN|LATEST_DROPDOWN",
  QUOTES = "POLICY|QUOTES|LATEST_POLICY_QUOTE_REFERENCE",
  CUSTOM_FORM_FIELDS = "POLICY|QUESTIONNAIRE|LATEST_POLICY_QUESTIONNAIRE",
  DOCUMENT_TRAINING = "DOCUMENT TRAINING|DOCUMENT TRAINING|LATEST_DOCUMENT_TRAINING",
}

export enum TRANSACTION_TYPE_ENUM {
  AuditPlus = "+ Audit",
  AuditMinus = "- Audit",
  Tax = "Tax",
  Reinstate = "Reinstate",
  Reissue = "Reissue",
  Rewrite = "Re-write",
  Correction = "Correction",
  Cancellation = "Cancellation",
  EndorsementPlus = "+ Endorsement",
  EndorsementMinus = "- Endorsement",
  Renewal = "Renewal",
  New = "New",
  FeeNSFFee = "Fee - NSF Fee",
  FeeServiceFee = "Fee - Service Fee",
  FeeInsuranceReports = "Fee - Insurance Reports",
  FeeFacilityFee = "Fee - Facility Fee",
  FeeMGAInsurerFee = "Fee - MGA/Insurer Fee",
  Payment = "Payment",
}

export enum MODULE_NAMES {
  LEADS = "Leads",
  FOLLOW_UP = "Follow Up",
  OPPORTUNITY = "Opportunity",
  CUSTOMER = "Customers",
  QUOTES = "Quotes",
  POLICIES = "Policies",
  LEGALS = "Legals",
  AUTOMOBILE = "Automobile",
  HABITATIONAL = "Habitational",
  BUSINESS = "Business",
  COMMERCIAL_AUTO = "Commercial Auto",
  POLICY_CHANGE = "Policy Change",
  NOTES = "Notes",
  BROKER_CONTACTS = "Broker Contacts",
  CSIO_EDI = "CSIO EDI",
  AUTOMOBILE_CLAIMS = "Automobile Claims",
  HABITATIONAL_CLAIMS = "HABITATIONAL_CLAIMS",
  COMMAUTO_CLAIMS = "COMMAUTO_CLAIMS",
  SUPPORT_TICKETS = "SUPPORT_TICKETS",
  ACCOUNTING_TASK = "ACCOUNTING_TASK",
  INVOICE_TRANSACTIONS = "INVOICE_TRANSACTIONS",
  PREMIMUM_FINANCE = "PREMIMUM_FINANCE",
  POLICY_UPDATES = "POLICY_UPDATES",
}

export const LOG_MODULES = {
  BUSINESS_POLICY: {
    moduleName: "Business Policy",
    subModules: {
      POLICY_CHANGE: "Policy Change Request"
    }
  },
  AUTOMOBILE_POLICY: {
    moduleName: "Automobile Policy",
    subModules: {
      POLICY_CHANGE: "Policy Change Request"
    }
  },
  COMM_AUTOMOBILE_POLICY: {
    moduleName: "Commercial Automobile Policy",
    subModules: {
      POLICY_CHANGE: "Policy Change Request"
    }
  },
  HABITATIONAL_POLICY: {
    moduleName: "Habitational Policy",
    subModules: {
      POLICY_CHANGE: "Policy Change Request"
    }
  }
}

export enum ROLES {
  ADMIN = "ADMIN",
  CSR = "CSR",
  PRODUCER_CL = "Producer-CL",
  PRODUCER = "Producer",
  HR = "HR",
  MANAGEMENT = "Management",
  CSR_HEADOFFICE = "CSR - Headoffice",
  BRANCH_MANAGER = "Branch Manager",
  ACCOUNTANT = "Accountant",
}

export enum TEMPLATE_RELATED_MODULE_ID {
  LEAD = "LEAD",
  FOLLOW_UP = "FOLLOW_UP",
  G4SIGN = "G4SIGN",
  TASK = "TASK",
  QUOTES = "QUOTES",
  INVOICE_TRANSACTIONS = "INVOICE_TRANSACTIONS",
}

export enum USER_ROLES {
  ADMIN = 1,
  CSR = 2,
  PRODUCER = 3,
  MARKETER = 4,
  BRANCH_MANAGER = 5,
}
export enum STATIC_ROLES_NAMES {
  ADMIN = "ADMIN",
  MANAGEMENT = "MANAGEMENT",
  ACCOUNTANT = "ACCOUNTANT",
  ACCOUNTANT1 = "ACCOUNTANT1",
  HR = "HR",
  CSR_HEADOFFICE = "CSR - Headoffice",
  BRANCH_MANAGER = "Branch Manager",
  CSR_BRANCH = "CSR - Branch",
  PRODUCER = "Producer",
}

export enum MASTER_DROP_DOWN_CODES {
  BUSINESS_POLICY_COVERAGE_EXCESS_LIABILITY = "1928871291",
  BUSINESS_POLICY_COVERAGE_UMBRELLA_LIABILITY = "1102862793",
  BUSINESS_POLICY_COVERAGE_LIABILITY = "1798940591",
  BUSINESS_POLICY_COVERGAE_CRIME = "2002268357",
  BUSINESS_POLICY_COVERAGE_MACHINERY_BREAKDOWN = "1858481030",
  BUSINESS_POLICY_COVERAGE_BUSINESS_INTERRUPTION = "1092620816",
  BUSINESS_POLICY_COVERAGE_PROPERTY = "903557867",
  USER_PERSONAL_INFORMATION_JOB_TITLE = "1336176649",
  REPORTS_FILTER_SUB_TYPE = "1111376833",
  LEADS_FOLLOWUP_TYPE = "1022114605",
  ALL_POLICY_SEGMENT_TYPE = "1160248986",
  GEN_AI_DOCUMENT_DOCUMENT_TYPE = "1370603313",
  GEN_AI_DOCUMENT_POLICY_TYPE = "1611842552"
}
